import React, { useState } from 'react';
import { BookMarked, GraduationCap, PlayCircle } from 'lucide-react';
import EnrolledCourses from '../../components/user/EnrolledCourses';
import MyLectures from '../MyLectures';

type Tab = 'courses' | 'lessons';

const PortalMyLearning: React.FC = () => {
  const [tab, setTab] = useState<Tab>('courses');

  return (
    <div className="pb-8 font-cairo" dir="rtl">
      <div className="border-b border-slate-100 bg-white px-4 pt-5 pb-5 sm:px-6 sm:pt-6 lg:px-8">
        <div className="mx-auto max-w-4xl">
          <div className="mb-5 text-center sm:mb-6 sm:text-start">
            <span className="mb-3 inline-flex items-center gap-1.5 rounded-full border border-orange-200 bg-orange-50 px-3 py-1 text-xs font-semibold text-orange-700 sm:text-sm">
              <BookMarked className="h-3.5 w-3.5" />
              مساحتك التعليمية
            </span>
            <h1 className="mb-2 text-2xl font-bold text-[#001848] font-cairo-bold sm:text-3xl">
              كورساتي وحصصي
            </h1>
            <p className="mx-auto max-w-xl text-sm text-slate-500 sm:mx-0 sm:text-base">
              كورساتك وحصصك في مكان واحد. كمّل من حيث وقفت.
            </p>
          </div>

          <div className="rounded-2xl border border-slate-200 bg-slate-50/80 p-1.5">
            <div className="grid grid-cols-2 gap-1.5">
              <button
                type="button"
                onClick={() => setTab('courses')}
                className={`inline-flex min-h-11 items-center justify-center gap-2 rounded-xl px-3 text-sm font-bold transition-all ${
                  tab === 'courses'
                    ? 'bg-[#001848] text-white shadow-md shadow-[#001848]/20'
                    : 'bg-transparent text-slate-600 hover:bg-white hover:text-[#001848]'
                }`}
              >
                <GraduationCap className="h-4 w-4 shrink-0" />
                كورساتي
              </button>
              <button
                type="button"
                onClick={() => setTab('lessons')}
                className={`inline-flex min-h-11 items-center justify-center gap-2 rounded-xl px-3 text-sm font-bold transition-all ${
                  tab === 'lessons'
                    ? 'bg-gold-500 text-white shadow-md shadow-gold-900/15'
                    : 'bg-transparent text-slate-600 hover:bg-white hover:text-[#001848]'
                }`}
              >
                <PlayCircle className="h-4 w-4 shrink-0" />
                حصصي
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[#F4F6FA]">
        {tab === 'courses' ? <EnrolledCourses embedded /> : <MyLectures embedded />}
      </div>
    </div>
  );
};

export default PortalMyLearning;
